import { Component } from '@angular/core';
import { InputTextComponent } from "../../../shared/components/input-text/input-text.component";
import { InputTextareaComponent } from "../../../shared/components/input-textarea/input-textarea.component";
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PanelModule } from 'primeng/panel';
import { InputSelectComponent } from "../../../shared/components/input-select/input-select.component";
import { ButtonModule } from 'primeng/button';
import { Router, RouterModule } from '@angular/router';
import { DateInputComponent } from "../../../shared/components/date-input/date-input.component";
import { MessageService } from 'primeng/api';
import { ElectionApiService } from '../../../core/services/election-api.service';
import { NewElectionRequest } from '../../../core/interfaces/election';
import { ToastModule } from 'primeng/toast';
import { User } from '../../../core/interfaces/user';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { periodValidator } from '../../../shared/validators/period.validator';
import { otherTypeValidator } from '../../../shared/validators/other-type.validator';
import { HasUnsavedChanges } from '../../../core/guards/unsaved-changes.guard';
import { CampaignApiService } from '../../../core/services/campaign-api.service';
import { InputNumberComponent } from "../../../shared/components/input-number/input-number.component";

@Component({
  selector: 'app-new-election',
  imports: [InputTextComponent,
    PanelModule,
    InputSelectComponent,
    InputTextareaComponent,
    ButtonModule,
    RouterModule,
    DateInputComponent,
    ToastModule,
    BlockUIModule,
    ProgressSpinnerModule, InputNumberComponent],
  templateUrl: './new-election.component.html',
  styleUrl: './new-election.component.scss',
  providers: []
})
export class NewElectionComponent implements HasUnsavedChanges {

    private saved = false;
    users!: User[]
    blockedDocument: boolean = false;
    loadingMessage = 'Loading...';
    electionForm = new FormGroup({
      name: new FormControl('', [Validators.required, Validators.maxLength(50)]),
      description: new FormControl('', [Validators.maxLength(250)]),
      active: new FormControl('', Validators.required,),
      type: new FormControl('', Validators.required,),
      processMethod: new FormControl('', Validators.required,),
      otherType: new FormControl(''),
      startDate: new FormControl(new Date(), Validators.required,),
      endDate: new FormControl(new Date(), Validators.required,),
      voteGoal: new FormControl('', [Validators.min(0), Validators.max(999999999)]),},
      {
        validators: [otherTypeValidator('type', 'otherType'),
          periodValidator('startDate', 'endDate')]
      }
    );

    statusList = [{"label":"No", "code": "false"},
                  {"label":"Yes", "code": "true"}]

    typeList! : any[]
    processMethodList! : any[]

    constructor(private messageService: MessageService, private router: Router,
                private electionApi: ElectionApiService,
                private campaignApi: CampaignApiService) {

        this.loadElectionTypeList();
        this.loadProcessMethodList();
    }

    hasUnsavedChanges(): boolean {
      return this.electionForm.dirty && !this.saved;
    }

    save() {

      if(this.electionForm.invalid) {
        this.electionForm.markAllAsTouched();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please, verify the required fields', life: 5000 })
        return;
      } else {
            const election = this.electionForm.value as NewElectionRequest
            if (election.type === 'OTHER') {
              election.type = this.electionForm.controls.otherType.value!;
            }
            election.processMethod = this.electionForm.controls.processMethod.value!;
            this.loadingMessage = 'Creating election...';
            this.blockedDocument = true;
            this.electionApi.createElection(election).subscribe({
                next: (data) =>{
                  this.blockedDocument = false;
                  this.saved = true;
                  this.messageService.add({ severity: 'success', summary: 'Success',
                    detail: "Saved." })
                  this.router.navigate(['/election/graphic/',data.campaignId]);
                } ,
                error: (err) => {
                  this.blockedDocument = false;
                  let errorMessage = ""
                  if(err.error.message) {
                    errorMessage += "Reason: " + err.error.message;
                  } else {
                    errorMessage =  "It wasn't possible to save the election.";
                  }
                  this.messageService.add({ severity: 'error', summary: 'Error',
                  detail: errorMessage, life: 5000 })
                      }

            })
      }

    }

    loadElectionTypeList() {
    this.electionApi.getElectionTypeList().subscribe({
        next: (data) =>{
          this.typeList = data;
        } ,
        error: (err) => {
          console.error('Error fetching data', err)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "It wasn't possible to load the page correctly.", life: 5000 })

        }
    })
  }

  loadProcessMethodList() {
    this.campaignApi.getProcessMethodList().subscribe({
        next: (data) =>{
          this.processMethodList = data;
        } ,
        error: (err) => {
          console.error('Error fetching data', err)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: "It wasn't possible to load the page correctly.", life: 5000 })

        }
    })
  }


}
